import React from 'react';
import Table from './Table';
class Performance extends React.Component {

  render() {
    return (
      <Table />
    )
  }
}

export default Performance;
